import React, { useEffect, useState } from 'react';

import { isEmpty, omit } from 'ramda';
import { FormSpy } from 'react-final-form';
import { useDispatch, useSelector, batch } from 'react-redux';

import { resetUnsavedChangesState, setAppHasChangesAction, registerEntity, setEntityState } from 'store/unsavedChanges';
import { multipleEntitiesRegisterSelector } from 'store/unsavedChanges/selectors';

function UnsavedChangesFormWatcher(params = {}) {
  const { ignoredFields = [], multiple = false, id } = params;
  const dispatch = useDispatch();
  const [hasChanges, setHasChanges] = useState(false);
  const multipleEntitiesRegister = useSelector(multipleEntitiesRegisterSelector);

  useEffect(() => {
    if (multiple) {
      dispatch(registerEntity({ id }));
    }

    return () => {
      dispatch(resetUnsavedChangesState());
    };
  }, [dispatch, id, multiple]);

  // watch form changes here
  useEffect(() => {
    if (multiple) {
      if (hasChanges) {
        batch(() => {
          dispatch(setEntityState({ id, value: true }));
          dispatch(setAppHasChangesAction(hasChanges));
        });
        return;
      }

      const isThereEntityWithChanges = multipleEntitiesRegister.entityIds
        .filter((entityId) => entityId !== id)
        .some((entityId) => multipleEntitiesRegister[entityId]);
      // since there are multiple forms on the page we want to set global flag to false only if other forms have no unsaved changes
      if (!isThereEntityWithChanges) {
        dispatch(setAppHasChangesAction(false));
      }

      dispatch(setEntityState({ id, value: false }));
      return;
    }
    dispatch(setAppHasChangesAction(hasChanges));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, hasChanges]);

  return (
    <FormSpy
      onChange={(state) => {
        setHasChanges(!state.submitting && !isEmpty(omit(ignoredFields, state.dirtyFields)));
      }}
    />
  );
}

export default UnsavedChangesFormWatcher;
